export default __webpack_public_path__ + "static/media/5-CloudOverTheMayor.4c36bdbf.jpeg";